import DepartmentManagement from './DepartmentManagement.vue'
export default DepartmentManagement


// WEBPACK FOOTER //
// ./src/pages/DepartmentManagement/index.js